// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__8dGka","wrapper":"PriceList_wrapper__XuwGO","footerStyle":"PriceList_footerStyle__Tbndp"};